import { Component, OnInit } from '@angular/core';
import { getAvatar } from 'src/app/helpers/getAvator';
import { AuthservicesService } from 'src/app/services/authservices.service';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-donations',
  templateUrl: './donations.component.html',
  styleUrls: ['./donations.component.css']
})
export class DonationsComponent implements OnInit {

  loading = true;

  pageNo = 1;
  pageSize = environment.pageSize;
  totalItems = 0;
  selectedStatus = 'all';
 

objArr: any[] = [];
arr: any[] = [];
arrList: any[] = [];

 donations: any[] = [];


  constructor(private authService: AuthservicesService) { }

  ngOnInit(): void {

    this.getDonations(1);
  }
  

  renderImage(data) {
    console.log("called render image with data", data);
    return this.authService.spilturl(data);
  }
  openMerchant(merchantId: string) {
  const url = `https://personal.ravel.faith/#/detail-page?keyword=Business&id=${merchantId}`;
  window.open(url, '_blank');
}
getDonations(event) {

  this.loading = false;
  this.objArr = [];
  this.pageNo = event;

  const skip = this.pageSize * (event - 1);

  (this.authService as any)
    .getDonations(skip, this.pageSize, this.selectedStatus)
    .subscribe((res: any) => {

      console.log("resp", res);

      this.loading = true;
      this.totalItems = res.data.total;

      this.objArr = [];

      res.data.data.forEach((e: any) => {

        this.objArr.push({
          id: e.subscriptionId,
          merchantId: e.merchantId,
          name: e.merchantName,
          photo: e.merchantImage
            ? this.renderImage(e.merchantImage)
            : '',
            avatar: getAvatar(e.merchantName),
            
          donationAmount: e.donationAmount,
          subscriptionAmount: e.subscriptionAmount,
          date: e.date,
          status: e.status,
          transferId: e.transferId
        });
        console.log("objArr", this.objArr);

      });

    });
}
onStatusChange() {
  this.getDonations(1);
}
}
